import { theme } from "@huub-web/ui/theme/css/theme.css";
import { style } from "@vanilla-extract/css";

export const bannerCardInnerStyle = style({
  borderRadius: theme.borderRadiuses.s,
});

export const gaugeStyle = style({
  flexShrink: 0,
});

// const BREAKPOINT = 700;

export const bannerCardContentStyle = style({
  alignItems: "center",
  // gap: theme.spacings.s,
  // flexDirection: "column",
  flexDirection: "row",
  gap: theme.spacings.l,
  // ...responsiveCard({
  //   [BREAKPOINT]: {
  //     flexDirection: "row",
  //     gap: theme.spacings.l,
  //   },
  // }),
});

export const allToLowerStyle = style({
  textTransform: "lowercase",
});
